module.exports = __webpack_public_path__ + "assets/img/llsj1.7354b86c.jpg";